import { events } from '~features/annals';
import { useSendEvent } from '~features/annals/useSendEvent';

export const useGenerateBotPublicStatus = ({
	status,
	botName,
}: {
	status: 'public' | 'private';
	botName: string;
}) =>
	useSendEvent(events.bot.generateBotPublicStatus, {
		bot_status: status,
		bot_name: botName,
	});

export const useUGCBotStatusChanged = ({
	botId,
	botName,
}: {
	botId: string;
	botName: string;
}) =>
	useSendEvent(events.bot.ugcBotStatusChange, {
		bot_UserId: botId,
		bot_name: botName,
	});

export const useUGCBotLinkCopied = ({
	botId,
	status,
	botName,
}: {
	botId: string;
	status: 'public' | 'private';
	botName: string;
}) =>
	useSendEvent(events.bot.ugcBotCopyLink, {
		bot_UserId: botId,
		bot_status: status,
		bot_name: botName,
	});

export const useUGCBotShareDiscordLinkClick = ({
	botId,
	status,
	botName,
}: {
	botId: string;
	status: 'public' | 'private';
	botName: string;
}) =>
	useSendEvent(events.bot.ugcBotDiscordShareClick, {
		bot_UserId: botId,
		bot_status: status,
		bot_name: botName,
	});

export const useUGCBotOptionsOpen = ({
	botId,
	status,
	botName,
	messagesCount,
}: {
	botId: string;
	status: 'public' | 'private';
	botName: string;
	messagesCount?: number;
}) =>
	useSendEvent(events.bot.ugcBotOptionsOpen, {
		bot_UserId: botId,
		bot_status: status,
		bot_name: botName,
		msgs: messagesCount,
	});
